import * as React from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import './Base.css';
const VerifyCheckAdoptSuccess = () => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    const dispatch = useDispatch();
    const processStateAction = (x) => ({ type: 'GOTO_PROCESS_STATE', processState: x });
    const submitData = (e) => {
        dispatch(processStateAction(e.currentTarget.value));
    };
    const showAuthorizationPdf = (e) => {
        dispatch({ type: 'GOTO_PROCESS_STATE', processState: "showAuthorizationCert" });
    };
    return React.createElement("div", null,
        React.createElement("div", null, "You are now authorized to deposit this check at your financial institution.  Please make sure to enter this authorization code on the check."),
        React.createElement("div", null,
            "Authorization Code: ",
            verifyCheckState.siteDraftCheck.authorizationCode),
        React.createElement("div", { className: "button_container" },
            React.createElement("button", { className: "btn btn-primary", name: "btnSubmit", value: "adoptSuccess", onClick: showAuthorizationPdf }, "Get Authorization Document")),
        React.createElement("div", null, "Important! Print or Save this authorization document before leaving this screen.  It can not be accessed once the page has been closed."),
        React.createElement("div", null, "\u00A0"),
        React.createElement("div", null, "Once you deposit this check at your financial institution.  Payment will fund provided the credit union has received by fax or email the following documents."),
        React.createElement("div", null,
            React.createElement("ul", null,
                React.createElement("li", null, "Copy of purchase Agreement (Buyer's Order) for the vehicle, signed by each borrower, and a representative of the Dealer."),
                React.createElement("li", null, "Invoice or NADA value sheet related to purchased security"))));
};
export default connect()(VerifyCheckAdoptSuccess);
//# sourceMappingURL=VerifyCheckAdoptSuccess.js.map